import React from "react";

import lockupWhite from "../../assets/wmu-lockup-white.svg";
import gigabyteLogo from "../../assets/gigabyte-lockup-white.png";

export default function Footer() {
  return (
    <footer className="Site-footer">
      <div className="Site-footer-inner">
        <div className="Site-footer-brand">
          <img src={ lockupWhite } alt="what's my uprn?" />
          <p>
            Built on OS AddressBase Core and Royal Mail PAF data.
            Contains OS data &copy; Crown copyright and database right;
            Royal Mail data &copy; Royal Mail copyright and database right.
          </p>
        </div>
        <div className="Site-footer-credit">
          <a href="https://gigabyte.software/" target="_blank" rel="noreferrer">
            <span>A Gigabyte Software product</span>
            <img src={ gigabyteLogo } alt="Gigabyte Software" />
          </a>
        </div>
      </div>
    </footer>
  );
}
